<template>
  <div>
    <v-row align="center" style="margin: 20px">
      <v-col class="d-flex" cols="8" sm="8" lg="7">
        <span>شاخص</span>
        <v-select
          :items="shakheses"
          item-text="Name"
          item-value="Serial"
          v-model="shakhes"
          return-object
          @input="getReportCard"
        ></v-select>
      </v-col>
    </v-row>
    <div>
      <div v-if="isMobile">
        <app-report
          v-for="item in reportCard"
          :key="item.Fserial"
          :reportCard="item"
        >
        </app-report>
      </div>
      <div v-else>
        <v-data-table
          :items="reportCard"
          :headers="ReportCardHeader"
          item-key="Fserial"
          class="elevation-1 rounded"
          show-expand
          single-expand
          :no-data-text="tableText"
          :item-class="rowClass"
          @item-expanded="onExpand"
          :footer-props="{
            itemsPerPageAllText: 'همه',
            itemsPerPageText: 'تعداد ردیف',
          }"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <div>
              <div class="py-4">
                <span class="titleTxt">
                  شاخص رتبه بندی
                </span>
                <span class="introductionTxt">
                  {{ item.TotalTitle }}
                </span>
              </div>
              <div v-if="item.Description" class="py-4">
                <span class="titleTxt">
                  توضیحات
                </span>
                <span class="introductionTxt">
                  {{ item.Description }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
            از {{ pageStart }} تا {{ pageStop }}
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import reportCardApp from "./ReportCardApp";

export default {
  components: {
    appReport: reportCardApp,
  },
  created() {
    this.$store.commit("SET_HEADER_TITLE", "رتبه بندی رزومه");
    this.$store.dispatch("getShakheses");
  },
  data() {
    return {
      ReportCardHeader: [
        {
          text: "عنوان",
          value: "FName",
          width: "60%",
        },
        {
          text: "دسته بندی",
          value: "Title",
          width: "20%",
        },
        // {
        //   text: "نمره",
        //   value: "score",
        //   width: "10%",
        // },
        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
      detailRoute: "/resume/reportCard",
      shakhes: "",
    };
  },
  computed: {
    getReportCard() {
      if (this.shakhes && this.shakhes.Serial) {
        this.$store.dispatch("getReportCard", {
          shakhesSerial: this.shakhes.Serial,
        });
      }
    },
    reportCard() {
      return this.$store.getters.resumeReportCard;
    },
    shakheses() {
      if (
        this.$store.getters.resumeShakheses &&
        this.$store.getters.resumeShakheses.length > 0 &&
        this.shakhes === ""
      ) {
        this.shakhes = this.$store.getters.resumeShakheses[0];
      }
      return this.$store.getters.resumeShakheses;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    rowClass(item) {
      let rowClass = item.Type == 2 ? "no-expand" : "";
      return rowClass;
    },
    onExpand(event) {
      if (event.value) {
        let relatedID = event.item.RelatedId;
        let type = event.item.Type;

        this.$store.dispatch("getSalaryDetails", {
          relatedID: relatedID,
          type: type,
        });
      }
    },
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
  },
};
</script>
<style>
.directionLTR {
  direction: ltr;
}
.backgroundGlobal {
  background-color: #e8e8e8 !important;
}
.titleTxt {
  padding: 10px;
  margin: 5px;
  font-size: 0.9rem;
  font-weight: 600;
}
</style>
